module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-nav-wrapper"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('comb.copyrightWorkManagement')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('word.total')) + " " + _vm._s(_vm.totalCount) + " " + _vm._s(_vm.$t('word.item')))])]), _vm._v(" "), _c('div', {
    staticClass: "tabs-wrapper"
  }, [_c('button', {
    class: {
      'active': _vm.statusCode === 0
    },
    on: {
      "click": function($event) {
        _vm.getWorkList(0, 1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('word.all')))])]), _vm._v(" "), _c('button', {
    class: {
      'active': _vm.statusCode === 1
    },
    on: {
      "click": function($event) {
        _vm.getWorkList(1, 1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('word.toBeAudit')))])]), _vm._v(" "), _c('button', {
    class: {
      'active': _vm.statusCode === 2
    },
    on: {
      "click": function($event) {
        _vm.getWorkList(2, 1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.passAudit')))])]), _vm._v(" "), _c('button', {
    class: {
      'active': _vm.statusCode === 5
    },
    on: {
      "click": function($event) {
        _vm.getWorkList(5, 1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.notPassAudit')))])])])]), _vm._v(" "), (_vm.totalCount === 0 && _vm.statusCode === 0) ? _c('div', {
    staticClass: "copyright-empty-work-list"
  }, [_c('p', {
    staticClass: "no-work"
  }, [_vm._v("您还没有上传作品，现在就去"), _c('router-link', {
    attrs: {
      "to": {
        name: 'uploadCopyright'
      }
    }
  }, [_vm._v("添加")]), _vm._v("作品制作有声读物吧 ")], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "copyright_blank_logo@2x.png")
    }
  })]) : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.pageLoading),
      expression: "pageLoading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "copyright-works-list-wrapper"
  }, _vm._l((_vm.workList), function(item) {
    return _c('div', {
      staticClass: "work-item"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(item.statusLabel))])])]), _vm._v(" "), _c('div', {
      staticClass: "work-content-wrapper"
    }, [(item.bookContract && item.bookContract.exclusive) ? _c('img', {
      staticClass: "prop-img",
      attrs: {
        "src": _vm.$store.state.IMG_HOST + 'exclusive-icon@2x.png'
      }
    }) : _vm._e(), _vm._v(" "), (item.coverImg) ? _c('img', {
      staticClass: "work-cover",
      attrs: {
        "src": _vm.$store.state.UPLOAD_IMG_HOST + item.coverImg
      }
    }) : _c('img', {
      staticClass: "work-cover",
      attrs: {
        "src": _vm.$store.state.IMG_HOST + 'bookCoverDefault.png'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "work-content",
      class: {
        'work-content-single': item.requirementId
      }
    }, [_c('div', {
      staticClass: "content"
    }, [_c('span', {
      staticClass: "work-name"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.author) ? _c('div', [_c('span', {
      staticClass: "work-anchor"
    }, [_vm._v(_vm._s(item.author))])]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "category-label"
    }, [_vm._v(_vm._s(item.categoryLabel))])]), _vm._v(" "), _c('div', {
      staticClass: "buttons"
    }, [(item.status === 5) ? _c('a', {
      staticClass: "check-task",
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.showAdvice(item.id)
        }
      }
    }, [_vm._v("查看建议")]) : _vm._e(), _vm._v(" "), (item.status === 9 && item.bookContract.ownerCoverCost) ? _c('a', {
      staticClass: "check-task",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.dialogVisible = true
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('comb.releaseTask')))]) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "check-task",
      attrs: {
        "type": "button",
        "to": {
          name: 'bookDetail',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('comb.checkWorkDetail')))]), _vm._v(" "), (item.requirementId) ? _c('router-link', {
      staticClass: "check-task",
      attrs: {
        "type": "button",
        "to": {
          name: 'workProgress',
          params: {
            id: item.materialId
          }
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('comb.checkRequirement')))]) : _vm._e()], 1)])])])
  })), _vm._v(" "), (_vm.totalPage >= 2) ? _c('div', {
    staticClass: "center-works-pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.pageIndex,
      "page-count": _vm.totalPage,
      "layout": "prev, pager, next"
    },
    on: {
      "current-change": _vm.changePage
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "页面跳转",
      "custom-class": "detailDialog",
      "size": "mini"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('span', [_vm._v("为了更好地为您服务，将前往喜配音平台进行后续操作！")]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('word.cancel')))]), _vm._v(" "), _c('a', {
    staticClass: "agree-btn",
    attrs: {
      "type": "button",
      "target": "_blank",
      "href": _vm.$store.state.DUB_HOST
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("跳转至喜配音")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dff4e170!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/center/WorksManagement.vue
// module id = 570
// module chunks = 0